import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useBreakpoints, useTheme } from '@monorepo/nova-ui';
import NotificationsClearedImage from '../assets/svg/notifications-cleared.svg?react';

export const NotificationsCleared: FC = () => {
  const { t } = useTranslation(['notificationCenter']);
  const { isMobile } = useBreakpoints();
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={isMobile ? '100%' : '192px'}
      padding="16px"
      borderRadius="16px"
      sx={{ backgroundColor: palette.background.paper }}
    >
      <Box marginBottom="16px">
        <NotificationsClearedImage />
      </Box>
      <Typography fontSize={14} fontWeight={500}>
        {t('notificationCenter:all_caught_up')}
      </Typography>
      <Typography fontSize={14} fontWeight={500}>
        {t('notificationCenter:you_are_all_set_for_now')}
      </Typography>
    </Box>
  );
};
